import * as React from "react"

function EditDoc(props) {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21 33V28.3875L29.2875 20.1375C29.5125 19.9125 29.7625 19.75 30.0375 19.65C30.3125 19.55 30.5875 19.5 30.8625 19.5C31.1625 19.5 31.45 19.5563 31.725 19.6688C32 19.7812 32.25 19.95 32.475 20.175L33.8625 21.5625C34.0625 21.7875 34.2188 22.0375 34.3313 22.3125C34.4438 22.5875 34.5 22.8625 34.5 23.1375C34.5 23.4125 34.45 23.6938 34.35 23.9813C34.25 24.2688 34.0875 24.525 33.8625 24.75L25.6125 33H21ZM23.25 30.75H24.675L29.2125 26.175L28.5375 25.4625L27.825 24.7875L23.25 29.325V30.75ZM9 33C8.175 33 7.46875 32.7063 6.88125 32.1188C6.29375 31.5313 6 30.825 6 30V6C6 5.175 6.29375 4.46875 6.88125 3.88125C7.46875 3.29375 8.175 3 9 3H21L30 12V16.5H27V13.5H19.5V6H9V30H18V33H9ZM28.5375 25.4625L27.825 24.7875L29.2125 26.175L28.5375 25.4625Z" fill="#D7DEE6" />
    </svg>

  )
}

export default EditDoc
